<template>
  <div data-testid="data-configuration" class="data-configuration">
    <nav
      data-testid="data-configuration__tabs"
      class="data-configuration__tabs"
      aria-label="Data configuration sections"
    >
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        :data-testid="`data-configuration__tab--${tab.key}`"
        class="data-configuration__tab"
        :class="{ 'data-configuration__tab--active': activeTab === tab.key }"
        @click="onTabChange(tab.key)"
      >
        {{ tab.label }}
      </button>
    </nav>

    <data-configuration-column-mapping-panel
      v-if="activeTabConfig"
      :key="activeTabConfig.key"
      :tab="activeTabConfig"
      :active="true"
      data-testid="data-configuration__mapping-panel"
    />
  </div>
</template>

<script>
import DataConfigurationColumnMappingPanel from './DataConfigurationColumnMappingPanel.vue';
import { ADMIN_CONSOLE_DATA_CONFIGURATION_TABS } from '@/modules/admin/utils/adminConsoleConstants';

export default {
  name: 'DataConfiguration',
  components: { DataConfigurationColumnMappingPanel },
  data() {
    return {
      activeTab: 'purchase-order',
      tabs: ADMIN_CONSOLE_DATA_CONFIGURATION_TABS,
    };
  },
  computed: {
    activeTabConfig() {
      return this.tabs.find((tab) => tab.key === this.activeTab) || null;
    },
  },
  methods: {
    onTabChange(tabKey) {
      if (this.activeTab === tabKey) return;
      this.activeTab = tabKey;
    },
  },
};
</script>

<style lang="scss" scoped src="./DataConfiguration.scss"></style>
